module.exports = __webpack_public_path__ + "img/candy_ball_2.bb565d3c.png";